<template>
  <!--线型图-->
  <div>
    <div :id="id" :style="`height: ${height}px;width:1400px`" class="chart" />
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: [String, Number],
      default: 'chart',
    },
    timeList: {
      type: Array,
      default: () => []
    },
    // 标题
    title: {
      type: String,
      default: ''
    },
    // 标题离容器右侧的距离
    titleRight: {
      type: String,
      default: '3%'
    },
    // 图表数据
    data: {
      type: Object,
      default: () => {},
    },
    // 图表高度
    height: {
      type: Number,
      default: 400,
    },
    // 图表区域上方边距
    gridTop: {
      type: Number,
      default: 20,
    },
    // 图表区域下方边距
    gridBottom: {
      type: Number,
      default: 30,
    },
    // 图表区域左侧边距
    gridLeft: {
      type: Number,
      default: 15,
    },
    // 图表区域右侧边距
    gridRight: {
      type: Number,
      default: 15,
    },
    // true：曲线，false：折线
    smooth: {
      type: Boolean,
      default: false,
    },
    // 图表类型
    type: {
      type: String,
      default: 'line',
    },
    // 是否显示图例
    legendShow: {
      type: Boolean,
      default: true,
    },
    // 图例排列方向
    legendOrient: {
      type: String,
      default: 'horizontal'
    },
    // 图例离容器上侧的距离
    legendTop: {
      type: String,
      default: 'bottom'
    },
    // 图例离容器右侧的距离
    legendRight: {
      type: String,
      default: 'center'
    },
    // x轴标签是否显示
    xAxisShow: {
      type: Boolean,
      default: true,
    },
    // y轴名称
    yAxisName: {
      type: String,
      default: ''
    },
    // 线条颜色
    linecolor: {
      type: Array,
      default: () => ['#FFB500', '#006df0', '#0acf97', '#fc7f03', '#d149fe', '#fe6d65', '#fcd02d', '#9ad864'],
    },
    // 平均线
    markLine: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // 图表配置
      optionEcharts: {
        // 标题
        title: {
          text: this.title,
          left: this.titleRight,
          textStyle: {
            fontSize: '14px',
            paddingTop: '15px',
            lineHeight: '30',
            color: '#281315 '
          }
        },
        // 提示框
        tooltip: {
          trigger: 'axis',
          confine: true, // 限制在图表区域内
          // formatter: '{{a}} {b}  {c}'
          // formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
          formatter(params) {
            // console.log(params)
            let relVal = params[0].data[2];
            for (let i = 0, l = params.length; i < l; i++) {
              relVal += `<br/>${params[i].marker}<span style="display:inline-block;width:90px;">${params[i].seriesName}</span> <span>${params[i].data[1]}</span> `;
              return relVal;
            }
          },
        },
        // 图例
        legend: {
          show: this.legendShow,
          // itemWidth: 6,
          // itemHeight: 6,
          top: this.legendTop,
          right: this.legendRight,
          orient: this.legendOrient, // 排列方向
          textStyle: {
            // color: '#ffffff'
          }
        },
        // 数据集
        dataset: {
          source: this.data.source,
        },
        // 图表区域大小
        grid: {
          top: this.gridTop,
          bottom: this.gridBottom,
          left: this.gridLeft,
          right: this.gridRight,
          containLabel: true, // 包含标签
        },
        // X轴
        xAxis: {
          type: 'category',
          axisLabel: {
            color: '#281315',
            show: this.xAxisShow,
          },
          boundaryGap: false,
          // 刻度线
          // axisTick: {
          //   show: false,
          // },
        },
        // y轴
        yAxis: {
          type: 'value',
          // max: 100,
          name: this.yAxisName, // 坐标轴名称
          nameTextStyle: { // 坐标轴名称样式
            color: '#281315',
            // padding:[0,20,0,0],
            align: 'right'
          },
          offset: 0, // 偏移
          position: 'left', // 位置
          axisLabel: {
            formatter: '{value}',
            color: '#281315'
          },
          // 刻度线
          axisTick: {
            show: false,
          },
          // 坐标轴线
          axisLine: {
            show: true,
          },
          // x轴网格线颜色
          splitLine: {},
        },
        // 系列
        series: [],
      },
    };
  },
  watch: {
    // 监听数据集
    data: {
      deep: true,
      handler(val) {
        // console.log(val)
        this.optionEcharts.dataset.source = val.source;
        this.initChart();
      },
    },
  },
  mounted() {
    this.charData(); // 处理数据
    this.initChart(); // 初始化echarts实例
  },
  methods: {
    charData() {
      // 提示框
      this.optionEcharts.tooltip = this.data.tooltip || this.optionEcharts.tooltip;
      // y轴数据
      this.optionEcharts.yAxis = this.data.yAxis || this.optionEcharts.yAxis;
      // 系列
      this.data.series.forEach((item, index) => {
        this.optionEcharts.series.push({
          name: item.name,
          lineStyle: '1',
          type: item.type, // 图表类型
          markLine: item.markLine, // 平均线
          yAxisIndex: item.yAxisIndex, // 有多条y轴时，设置y轴索引
          color: item.color || this.linecolor[index], // 线颜色
          smooth: this.smooth, // 曲线、折线
          symbolSize: '7', // 折点大小
          symbol: 'circle',
          areaStyle: item.areaStyle // 区域样式
        });
      });
    },
    initChart() {
      // const char = this.$echarts.init(document.getElementById(this.id))
      const echarts = require('echarts');
      const chartList = document.getElementById(this.id);
      // 初始化echarts实例
      const chart = echarts.init(chartList);
      this.$nextTick(() => {
        // 图表配置
        chart.setOption(this.optionEcharts);
        // 图表的自适应
        window.addEventListener('resize', () => {
          chart.resize();
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep .chart{
    min-width: 250px;
    width: 100%;
  }
</style>
